import { toNumber } from 'ethers';
import { Round } from '../model/round.model';
import { formatUsdc, formatUsdcToTokenPrice } from '../utils/web3-convert.utils';

// Mapper for Round
export const mapRound = (data: any): Round => {
    return {
        roundStatus: data.roundStatus,
        roundType: data.roundType,
        allocation: toNumber(data.allocation),
        isStakable: data.isStakable,
        tokenPrice: formatUsdcToTokenPrice(data.tokenPrice)
    };
}; 